import { faqItems } from '@/mocks/homeData';

export default function FAQSection() {
  return (
    <section id="faq" className="w-full py-14 md:py-20 bg-background-100 scroll-mt-20">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-3xl mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <h2 className="text-2xl md:text-4xl font-heading text-foreground-900 mb-3">
              常见问题
            </h2>
            <p className="text-sm md:text-base text-foreground-500">
              关于7788电影网，你想知道的都在这里
            </p>
          </div>

          <div className="flex flex-col gap-3 md:gap-4">
            {faqItems.map((item) => (
              <div
                key={item.question}
                className="bg-background-50 border border-background-200/70 rounded-lg p-5 md:p-6"
              >
                <h3 className="text-sm md:text-base font-heading text-foreground-900 mb-2 md:mb-3">
                  {item.question}
                </h3>
                <p className="text-xs md:text-sm text-foreground-500 leading-relaxed">
                  {item.answer}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}